(() => {
  "use strict";

  if (window.__fpWishlistAuthBridgeV021) return;
  if (location.protocol !== "https:" ||
      location.hostname !== "flauschpalast.com" ||
      location.pathname !== "/pages/flauschwishlist-auth") return;
  window.__fpWishlistAuthBridgeV021 = true;

  const CLIENT_ID = "72e42ec4-62d6-4e29-a1c9-16c1599b3f74";
  const ORIGIN = "https://flauschpalast.com";
  const CALLBACK = ORIGIN + "/pages/flauschwishlist-auth";
  const TRANSACTION = `fp:wishlist:customer-auth:v1:${ORIGIN}:${CLIENT_ID}`;
  const TOKEN = `fp:wishlist:customer-token:v1:${ORIGIN}:${CLIENT_ID}`;
  const TTL_MS = 10 * 60 * 1000;
  const MAX_CLOCK_SKEW = 30 * 1000;
  const STATE = /^[A-Za-z0-9_-]{32,256}$/;
  const VERIFIER = /^[A-Za-z0-9_-]{43,128}$/;

  function show(message, isError = false) {
    let element = document.getElementById("fp-wishlist-auth-bridge-status");
    if (!element) {
      element = document.createElement("div");
      element.id = "fp-wishlist-auth-bridge-status";
      element.setAttribute("aria-live", "polite");
      document.body.appendChild(element);
    }
    element.replaceChildren();
    element.setAttribute("role", isError ? "alert" : "status");
    element.classList.toggle("fp-wishlist-auth__status--error", isError);
    const copy = document.createElement("p");
    copy.className = "fp-wishlist-auth__status-text";
    copy.textContent = message;
    element.appendChild(copy);
    const note = document.getElementById("fp-wishlist-auth-bridge-note");
    if (note) note.hidden = isError;
    if (isError) {
      const link = document.createElement("a");
      link.href = ORIGIN + "/";
      link.textContent = "Zurück zum FlauschPalast";
      link.className = "fp-wishlist-auth__link";
      element.appendChild(link);
    }
  }

  function fail(code) {
    const error = new Error(code);
    error.name = "FlauschWishlistAuthBridgeError";
    return error;
  }

  function validReturnUrl(value) {
    const url = new URL(value || "/", ORIGIN);
    if (url.origin !== ORIGIN || !/^https:$/.test(url.protocol)) {
      throw fail("UNSAFE_RETURN_URL");
    }
    if (url.pathname === "/pages/flauschwishlist-auth") {
      throw fail("CALLBACK_LOOP_BLOCKED");
    }
    // Preserve an explicit preview_theme_id in returnTo while staging; never inject it for live customers.
    return url.href;
  }

  function readTransaction() {
    let transaction;
    try {
      transaction = JSON.parse(sessionStorage.getItem(TRANSACTION) || "null");
    } catch {
      throw fail("AUTH_TRANSACTION_STORAGE_ERROR");
    }
    const age = Date.now() - transaction?.createdAt;
    if (!transaction || !Number.isFinite(age) || age < -MAX_CLOCK_SKEW ||
        age > TTL_MS || !STATE.test(transaction.state || "") ||
        !VERIFIER.test(transaction.verifier || "")) {
      throw fail("AUTH_TRANSACTION_INVALID");
    }
    return transaction;
  }

  async function fetchJson(url, init) {
    const address = new URL(url, ORIGIN);
    if (address.protocol !== "https:" ||
        !(address.hostname === "shopify.com" ||
          address.hostname.endsWith(".shopify.com") ||
          address.hostname === "flauschpalast.com")) {
      throw fail("UNTRUSTED_OAUTH_ENDPOINT");
    }
    const response = await fetch(address.href, {
      ...init,
      cache: "no-store",
      signal: typeof AbortSignal.timeout === "function" ? AbortSignal.timeout(15000) : undefined
    });
    if (!response.ok) throw fail(`OAUTH_HTTP_${response.status}`);
    const payload = await response.json();
    if (!payload || typeof payload !== "object") throw fail("OAUTH_INVALID_RESPONSE");
    return payload;
  }

  async function run() {
    const current = new URL(location.href);
    const code = current.searchParams.get("code");
    const state = current.searchParams.get("state");
    const oauthError = current.searchParams.get("error");

    if (!code && !oauthError) {
      show("Hier ist gerade keine Anmeldung offen. Deine Herzensstücke bleiben auf diesem Gerät erhalten.", true);
      return;
    }

    for (const key of ["code", "state", "error", "error_description", "id_token", "access_token"]) {
      current.searchParams.delete(key);
    }
    history.replaceState(history.state, "", current.pathname + current.search + current.hash);

    let transaction;
    try {
      transaction = readTransaction();
      if (!state || transaction.state !== state) throw fail("AUTH_STATE_MISMATCH");
      if (oauthError) throw fail("OAUTH_REJECTED_" + String(oauthError).slice(0, 48));
      if (!code || typeof code !== "string" || code.length > 4096) throw fail("AUTH_CODE_INVALID");
      const returnTo = validReturnUrl(transaction.returnTo);

      show("Wir schließen deine Anmeldung sicher ab. Gleich geht es weiter …");
      const discovery = await fetchJson(`${ORIGIN}/.well-known/openid-configuration`, {
        method: "GET", headers: { Accept: "application/json" }
      });
      if (typeof discovery.token_endpoint !== "string") throw fail("TOKEN_ENDPOINT_MISSING");

      const body = new URLSearchParams({
        grant_type: "authorization_code",
        client_id: CLIENT_ID,
        redirect_uri: CALLBACK,
        code,
        code_verifier: transaction.verifier
      });
      const payload = await fetchJson(discovery.token_endpoint, {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString()
      });
      const expiresIn = Number(payload.expires_in);
      if (typeof payload.access_token !== "string" ||
          !payload.access_token || !Number.isFinite(expiresIn) || expiresIn <= 0) {
        throw fail("TOKEN_INVALID");
      }
      sessionStorage.setItem(TOKEN, JSON.stringify({
        accessToken: payload.access_token,
        expiresAt: Date.now() + expiresIn * 1000,
        obtainedAt: Date.now()
      }));
      sessionStorage.removeItem(TRANSACTION);
      show("Geschafft! Wir bringen dich zurück zu deinen Herzensstücken …");
      location.replace(returnTo);
    } catch (error) {
      try { sessionStorage.removeItem(TRANSACTION); } catch {}
      // A guest must never remain stranded on the OAuth callback page.
      // A matching prompt=none login_required returns to the untouched
      // local wishlist and pauses further silent attempts for 90 seconds.
      const needsLogin = ["login_required", "interaction_required", "consent_required"].includes(oauthError);
      if (needsLogin && error?.message === "OAUTH_REJECTED_" + oauthError && transaction) {
        try {
          sessionStorage.setItem(
            `fp:wishlist:silent-auth-failed:v1:${CLIENT_ID}:${ORIGIN}`,
            String(Date.now() + 90000)
          );
          location.replace(validReturnUrl(transaction.returnTo));
          return;
        } catch {}
      }
      console.warn("FlauschWishlist OAuth callback:", error?.message || "UNKNOWN");
      show("Die Anmeldung hat diesmal nicht geklappt. Deine lokal gespeicherten Herzensstücke bleiben erhalten.", true);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => { void run(); }, { once: true });
  } else {
    void run();
  }
})();
